<script>
import {
  iKeyIcon,
  iKeyIconSize,
  iKeyIconShape,
  iKeyIconStyle,
  iKeyIconType,
} from '@inscribe/signal';

export default {
  components: { iKeyIcon },
  props: {
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: 'small-user-single',
    },
  },
  data() {
    return { iKeyIconSize, iKeyIconShape, iKeyIconStyle, iKeyIconType };
  },
};
</script>
<template>
  <div class="icon-text d-flex flex-row i-gap-8">
    <i-key-icon
      :size="iKeyIconSize.MD"
      :shape="iKeyIconShape.SQUARE"
      :icon-style="iKeyIconStyle.OUTLINE"
      :type="iKeyIconType.NEUTRAL"
      :icon="icon"
      class="user-icon"
    ></i-key-icon>
    <div class="user-text d-flex flex-column">
      <router-link
        v-if="link"
        class="i-text-subheading-2 i-text-neutral-120"
        :to="link"
        :aria-label="title"
        >{{ title }}</router-link
      >
      <div v-else class="i-text-subheading-2 i-text-neutral-120">
        {{ title }}
      </div>
      <div class="i-text-body-2 i-text-neutral-110">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>
